import React from 'react';
import {createRoot} from "react-dom/client";
import MultiStepForm from "./MultiStepForm";

const root = createRoot(document.getElementById('juno-survey-root'))
root.render(<MultiStepForm />)